module.exports = __webpack_public_path__ + "static/media/34.60267902.jpg";